import { render } from "./InstallScreen.vue?vue&type=template&id=7b296ef3&scoped=true"
import script from "./InstallScreen.vue?vue&type=script&lang=js"
export * from "./InstallScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=7b296ef3&lang=scss&scoped=true"
import "./InstallScreen.vue?vue&type=style&index=1&id=7b296ef3&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b296ef3"]])

export default __exports__